// --- src/pages/Benefits.js ---
import React from "react";
import { PiggyBank, MapPin, Clock, Headphones } from "lucide-react";

const benefits = [
  {
    icon: <PiggyBank size={28} />,
    title: "Affordable Pricing",
    description: "Get the best property deals without breaking the bank.",
  },
  {
    icon: <MapPin size={28} />,
    title: "Prime Locations",
    description: "Access listings in top-tier neighborhoods and hotspots.",
  },
  {
    icon: <Clock size={28} />,
    title: "Quick Closings",
    description: "Experience fast and hassle-free property transactions.",
  },
  {
    icon: <Headphones size={28} />,
    title: "24/7 Support",
    description: "We’re here to help any time, any day of the week.",
  },
];

const Benefits = () => (
  <section className="py-20 bg-brand px-6 md:px-20">
    <h2 className="text-3xl font-bold text-center mb-12">Why Choose Me?</h2>

    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
      {benefits.map((benefit, index) => (
        <div
          key={index}
          className="bg-white rounded-2xl shadow-md hover:shadow-xl transition p-6 text-center transform hover:-translate-y-1 duration-300"
        >
          <div className="text-yellow-500 mb-4 flex justify-center">
            {benefit.icon}
          </div>
          <h3 className="text-lg font-semibold mb-2">{benefit.title}</h3>
          <p className="text-gray-600 text-sm">{benefit.description}</p>
        </div>
      ))}
    </div>
  </section>
);

export default Benefits;
